import { saveAs } from 'file-saver';

export const downloadFile = async function({contents, type='text/plan', encoding='utf-8', filename='Unnamed file'}){
  const blob = new Blob([contents], {type: `${type};charset=${encoding}`});
  return saveAs(blob, filename);
}
